import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

interface ITextAreaAutoSizeProps {
    id?: string;
    dataCy?: string;
    disabled?: boolean;
    cssClass?: string;
    onTextChangeCallback?: (value: string) => void;
    value?: string;
    focus?: boolean;
    nowrap?: boolean
    minHeight?: string;
    maxHeight?: string;
    isInvalid?: boolean;
    maxLength?: number;
}

class TextAreaAutoSize extends BaseReactComponent<ITextAreaAutoSizeProps, never> {
    public textAreaRef: HTMLTextAreaElement;

    constructor(props: ITextAreaAutoSizeProps) {
        super(props);
    }

    public componentDidMount(): void {
        if (this.textAreaRef) {
            autosize(this.textAreaRef);
        }

        if (this.props.focus === true)
            this.textAreaRef?.focus();
    }

    public componentWillUnmount(): void {
        try {
            let evt = document.createEvent("Event");
            evt.initEvent("autosize:destroy", true, false);

            if (this.textAreaRef) {
                this.textAreaRef.dispatchEvent(evt);
            }
        }
        catch (e) {
            console.warn("failed to destroy autoresize box");
        }

        super.componentWillUnmount();
    }

    public render(): JSX.Element {
        return (
            <textarea
                ref={ref => this.textAreaRef = ref}
                onChange={e => this.props.onTextChangeCallback?.(e.target.value)}
                value={this.props.value}
                id={this.props.id}
                data-cy={this.props.dataCy}
                style={this.cssStyle}
                className={`vresize form-control ${this.props.cssClass ?? ""} ${this.props.isInvalid ? "invalid" : ""}`}
                disabled={this.props.disabled === true}
                maxLength={this.props.maxLength}
            />
        );
    }

    private get cssStyle(): React.CSSProperties {
        let cssStyle: React.CSSProperties = {};

        if (this.props.nowrap === true)
            cssStyle.whiteSpace = "pre";

        if (this.props.minHeight)
            cssStyle.minHeight = this.props.minHeight;

        if (this.props.maxHeight)
            cssStyle.maxHeight = this.props.maxHeight;

        return cssStyle;
    }
}

export { TextAreaAutoSize };
